import type InboxRule from 'owa-service/lib/contract/InboxRule';
import { action } from 'satcheljs';

const defaultExport: (inboxRule: InboxRule) => {
    inboxRule: InboxRule;
} = action(
    'onCreateUpdateRuleSuccessFromCopilotChat',
    function onCreateUpdateRuleSuccessFromCopilotChat(inboxRule: InboxRule): {
        inboxRule: InboxRule;
    } {
        return { inboxRule };
    }
);
export default defaultExport;
